import { render } from "./VacancyAutocomplete.vue?vue&type=template&id=51278ff6"
import script from "./VacancyAutocomplete.vue?vue&type=script&lang=js"
export * from "./VacancyAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__